import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/Skeleton';
import { useEffect, useState } from 'react';

export default function ReportedChatSkeleton() {
  const [randomNumber, setRandomNumber] = useState(80);
  useEffect(() => {
    const counter = setInterval(() => {
      setRandomNumber(Math.floor(Math.random() * 100));
    }, 1700);
    return () => clearInterval(counter);
  });
  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-1 flex-col gap-3 overflow-auto bg-coal-100 p-4">
        {Array.from({ length: 16 }).map((_, index) => (
          <div
            key={index}
            className={cn('flex', index % 2 === 0 ? 'justify-start' : 'justify-end')}
          >
            <Skeleton
              style={{ width: `${Math.floor(Math.random() * randomNumber)}%` }}
              className={cn(
                'h-8 rounded-lg p-2 transition-all duration-500',
                index % 2 === 0 ? 'rounded-tl-none' : 'rounded-tr-none'
              )}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
